var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavaScriptframeworksBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.07,222.06c1.54-41.41-13.35-83.33-46.15-103.29-16.19-9.85-35.12-15.62-54.06-14.77-20.32.91-39.45,9.18-58.61,16s-39.91,12.28-59.66,7.44c-14.29-3.51-26.86-12.15-41-16.1C101.88,95.84,53.37,159,80.63,209.26c6.69,12.32,17,22.2,25.67,33.24s15.94,24.34,14.77,38.32c-1,11.56-7.56,21.87-10.29,33.15-5.22,21.6,5.14,45.38,23.05,58.54s42.07,16.27,63.63,10.86,40.59-18.68,55.57-35.11c8-8.79,15.83-19.08,27.35-22.06,11-2.87,22.44,1.79,33.64,3.93a77.48,77.48,0,0,0,59.77-13.59C400.89,296.52,415.69,259.5,417.07,222.06Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.07,222.06c1.54-41.41-13.35-83.33-46.15-103.29-16.19-9.85-35.12-15.62-54.06-14.77-20.32.91-39.45,9.18-58.61,16s-39.91,12.28-59.66,7.44c-14.29-3.51-26.86-12.15-41-16.1C101.88,95.84,53.37,159,80.63,209.26c6.69,12.32,17,22.2,25.67,33.24s15.94,24.34,14.77,38.32c-1,11.56-7.56,21.87-10.29,33.15-5.22,21.6,5.14,45.38,23.05,58.54s42.07,16.27,63.63,10.86,40.59-18.68,55.57-35.11c8-8.79,15.83-19.08,27.35-22.06,11-2.87,22.44,1.79,33.64,3.93a77.48,77.48,0,0,0,59.77-13.59C400.89,296.52,415.69,259.5,417.07,222.06Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.79,
    cy: 423.19,
    rx: 135.21,
    ry: 32.87,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.79,
    cy: 423.19,
    rx: 135.21,
    ry: 32.87,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 108.43,
    y1: 200.03,
    x2: 109.33,
    y2: 200.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.11,
    y1: 201.38,
    x2: 245.83,
    y2: 269.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1.9968299865722656,1.9968299865722656"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "246.72 269.49 247.62 269.94 247.12 269.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246.15,
    y1: 267.35,
    x2: 162.7,
    y2: 119.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1.9836399555206299,1.9836399555206299"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.21,
    y1: 118.83,
    x2: 161.72,
    y2: 117.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.75,
    y1: 200.03,
    x2: 385.85,
    y2: 200.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 384.07,
    y1: 201.38,
    x2: 249.35,
    y2: 269.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1.9968299865722656,1.9968299865722656"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "248.46 269.49 247.56 269.94 248.05 269.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.03,
    y1: 267.35,
    x2: 332.48,
    y2: 119.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1.9836399555206299,1.9836399555206299"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.97,
    y1: 118.83,
    x2: 333.46,
    y2: 117.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.62,
    y1: 269.94,
    x2: 247.62,
    y2: 268.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.62,
    y1: 266.93,
    x2: 247.62,
    y2: 90.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2.0179100036621094,2.0179100036621094"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.62,
    y1: 89.35,
    x2: 247.62,
    y2: 88.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.29,316.74,214,428a1.08,1.08,0,0,0,.91,1.19h0a1.07,1.07,0,0,0,.92-1.14L218,316.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.7,313.16l.27,97.08a.92.92,0,0,1-.78,1h0a.91.91,0,0,1-.77-1l-1.85-97Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,313.16l.27,97.08a.92.92,0,0,1-.78,1h0a.91.91,0,0,1-.77-1l-1.85-97Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.69,316.74,283,428a1.08,1.08,0,0,1-.91,1.19h0a1.08,1.08,0,0,1-.92-1.14L279,316.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248,
    cy: 314.36,
    rx: 44.5,
    ry: 10.17,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5,272.86s-9.5,14.5-9.5,23.5,6,16.5,10.5,19,50.5.5,50.5.5,12.5-7.5,11-20c-1.25-10.43-9.5-22.5-9.5-22.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,411.36s-2.5,15-6.5,21-10,4.5-9.5-2.5,7-18.5,7-18.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.73,426c0,2.35.72,4.84,3.36,5.77,3.37,1.19,6.73-3.89,9.14-8.33a115,115,0,0,0,2.8-12.11h-9S227.53,419.33,225.73,426Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,287.36s9.5,6,12,13.5-5.5,110.5-5.5,110.5h-9s-4-42-7-56.5,1.5-34,1.5-37-13,3.5-14-21.5",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.5,411.36s2.5,15,6.5,21,10,4.5,9.5-2.5-7-18.5-7-18.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1,431.15c2.47,0,3.59-1.61,4-3.71-1.48-6.94-6.64-16.08-6.64-16.08h-9s.84,5.05,2.33,10.46C260.11,426.11,263.55,431.15,267.1,431.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.53,287.36s-9.5,6-12,13.5,5.5,110.5,5.5,110.5h9s4-42,7-56.5-1.5-34-1.5-37,14.47,3,15.47-22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,283.19l-.49,121.23a1.44,1.44,0,0,0,1.44,1.44h0a1.43,1.43,0,0,0,1.43-1.39l3.46-121.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.47,311.53,127,436.86a1.43,1.43,0,0,0,1.44,1.44h0a1.44,1.44,0,0,0,1.44-1.38l3.45-125.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.23,283.19l.49,121.23a1.43,1.43,0,0,1-1.43,1.44h0a1.44,1.44,0,0,1-1.44-1.39L357.4,283.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.4,311.53l.49,125.33a1.43,1.43,0,0,1-1.44,1.44h0a1.43,1.43,0,0,1-1.43-1.38l-3.45-125.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.46,304.75l-3.6-3.24-8.32-18a4.79,4.79,0,0,0-4.36-2.71H138.58a4.79,4.79,0,0,0-4.37,2.71L123.84,306l-1.71-.63v5.13l.08-.06a2.84,2.84,0,0,0,2.87,2.43H373.67a2.81,2.81,0,0,0,2.87-2.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.67,308.11H125.08a2.76,2.76,0,0,1-2.64-3.86l11.77-25.43a4.77,4.77,0,0,1,4.37-2.71h221.6a4.77,4.77,0,0,1,4.36,2.71l11.78,25.43A2.77,2.77,0,0,1,373.67,308.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87,197.75s-7.64,1.36-11.27,3.74-16.73,6.82-18.55,9.88-13.09,42.93-13.46,46,3.28,6.13,7.64,6.13,14.55-28.27,14.55-28.27l4.36,14.31-10.23,30h61.6l-7.73-31,4-15,13.46,33s5.82,5.79,9.45-.68-8-31.68-9.09-36.79-5.45-17-8.73-20.78-12.72-7.5-18.18-9.54S250.69,197.41,244.87,197.75Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "278.95 221.81 275.78 233.52 280.08 228.04",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "219.55 221.25 223.78 235.22 217.29 226.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6,218.53c11,.27,14.4-11.54,14.77-19.12l-1.68-.64c-5.45-2-12-1.36-17.82-1A51.89,51.89,0,0,0,236.6,200C237,206,239.19,218.27,249.6,218.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.6 218.53 225.96 279.16 271.78 279.16 249.6 218.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.13,260.31s-6.43,1.34-8.58,4.92-4.77,8.93-7.39,12.06l7.63,4s8.1-6,11.2-8.49a8.89,8.89,0,0,0,2.15-11.39",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.7,266.79c-3.63-1.58-6.19-1.17-7.79-.48-2,3.51-4.38,8.15-6.75,11l7.63,4s8.1-6,11.2-8.49a9,9,0,0,0,1.18-1.13A11.43,11.43,0,0,0,292.7,266.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.87,276.08s-3.34-.45-5.25.67-5.72,5.58-4.53,6.25,3.58-3.57,4.77-3.57a18.11,18.11,0,0,1,3.82.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.68,276.16s-4.53-1.34-7.15-.9-6.2,7.6-7.39,9.83-.24,2.9.71,2.23,4.06-5.58,4.06-5.58L272.28,288a1.07,1.07,0,0,0,1.43.45c1-.45,4.31-7.16,4.31-7.16l-1.92,6.94a1.35,1.35,0,0,0,1.43.44c1-.22,3.57-5.8,3.57-5.8s-2.38,6.47-1.67,6.7a2.38,2.38,0,0,0,2.39-1.57,50.6,50.6,0,0,1,4.77-6.7C287.78,280,287.3,277.27,284.68,276.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.91,
    y1: 281.74,
    x2: 277.11,
    y2: 278.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.02,
    y1: 281.28,
    x2: 279.02,
    y2: 278.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.1,
    y1: 282.86,
    x2: 281.98,
    y2: 280.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.94,183s1.55,4-1.24,10.86-1.25,17,.62,22,5.27,10.55,6.2,9.31,2.79-15.51,3.1-25.12-.62-16.44-2.79-19.54S229.63,179,229.94,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.52,225.16s-2.17,5.89-2.17,10.23,5.27,6.82,5.27,6.82,2.79-4.65,1.86-9.3S235.52,225.16,235.52,225.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,177.87s-2.28-3.94-4.07-1.91,1.44,6.7,3.23,8.25,3.11.6,3-1.07S230.81,177.87,230.81,177.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,177.87s2.27-3.94,4.07-1.91-1.44,6.7-3.23,8.25-3.12.6-3-1.07S267,177.87,267,177.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,209.16c.94-5,1.5-11.79,1.5-11.79s-11.25,1.56-15-.59c0,0,1.61,7.21,3.43,12.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.05,179.19s3.11,11,9,17.47,8,8,11.13,7.53,6.46-4.54,11.12-13,5-15,5.39-15.55-1-12.56-7.66-17.71-14.12-7.41-20.58-1.79S228.89,170.93,231.05,179.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.15,184.93a48.77,48.77,0,0,0-.6,7.06c.12,2.39.84,3.11-.24,3.35S248,193.9,248,193.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.84,
    y1: 198.34,
    x2: 251.23,
    y2: 198.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.82,182.82s-2.28-5.63-9.81-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.09,182.12s1.91-5.5,8.73-2.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.18,185.33c0,1.09-.44,2-1,2s-1-.89-1-2,.44-2,1-2S243.18,184.23,243.18,185.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.32,
    cy: 185.33,
    rx: 0.99,
    ry: 1.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.66,187.39c0,2.44-2.81,4.42-6.28,4.42s-6.28-2-6.28-4.42,2.62-3.48,6.09-3.48S247.66,184.94,247.66,187.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.58,187.39c0,2.44-2.81,4.42-6.28,4.42s-6.29-2-6.29-4.42,2.63-3.48,6.1-3.48S263.58,184.94,263.58,187.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.3,185.77s1.55-.93,4,.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.33,147.61c-13.53-5.81-23,0-23,0a14.7,14.7,0,0,0-2.61,1.83c-4.61,4.15-7.42,12-7.06,18.54a24.11,24.11,0,0,0,4.55,12,27.9,27.9,0,0,0,8.13-9.1,76.41,76.41,0,0,0,4-8.17c0,2.93.38,6.47,1.92,9a12.78,12.78,0,0,0,11.22,6.56,10.57,10.57,0,0,0,2.35-.23.5.5,0,0,0,.32-.25c3.86.82,7.7.75,8.29-.07.95-1.31,2.3-5.4,2.75-10.4C270.91,158.84,265.57,151.48,259.33,147.61ZM246.09,171.1c-1.94-3.17-1.88-8.34-1.65-11.31l.13-.34a20.36,20.36,0,0,0,8.13,15.67,14.65,14.65,0,0,0,4.43,2.07C254.68,177.35,249.64,176.89,246.09,171.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.26,155.39s-.82,6.06,6.88,12,15,3.6,15,3.6",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.39,153.33s8.11,11.81,19.31,8.73",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.15,256.14a50.31,50.31,0,0,0-8.85,3.73c-4,2.27-18.38,10.49-22.71,11.81s-6.76,1.11-8.86,3.3-8.77,9.13-9.62,12.14.48,2.69,1.7,1.87,4.68-5.17,7.74-5.47,4.26-.19,4.3,1.45-2,7.09-.38,6.62,2.34-3,3.36-5.78.9-6.71,1.43-7.72,16.29-4,21.29-4.93,13.5-4.07,16-6.14,4.27-8.12,4.27-8.12",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,285s-6.12,4.08-5.35,6.88,6.12,3.83,9.18,2.3,5.36-2.55,5.87-6.38-.77-5.35-3.57-5.35S158.46,285,158.46,285Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,273.16a59.51,59.51,0,0,0,8.82-2.62c-1.77-6.13-5.48-8.73-8.66-9.81-5.44,2.9-17.24,9.76-21.12,10.95-4.34,1.33-6.76,1.11-8.86,3.3s-8.77,9.13-9.62,12.14.48,2.69,1.7,1.87,4.68-5.17,7.74-5.47,4.26-.19,4.3,1.45-2,7.09-.38,6.62,2.34-3,3.36-5.78.9-6.71,1.44-7.72S187.55,274.13,192.55,273.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.7,279.44s-5.22,2.7-6.33,4-2,6.17-.43,5.91,3.05-3.78,3.75-4.51a12.54,12.54,0,0,1,3.42-1.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.64,
    cy: 294.36,
    rx: 39.23,
    ry: 7.34,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.64,
    cy: 294.36,
    rx: 39.23,
    ry: 7.34,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,295.28H213.35a1.15,1.15,0,0,1-1.16-1.15h0a1.15,1.15,0,0,1,1.16-1.15H281.9a1.14,1.14,0,0,1,1.15,1.15h0A1.14,1.14,0,0,1,281.9,295.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,293H212.76a1,1,0,0,1-1-.94l-3.79-45.55a1,1,0,0,1,1-1.12h77.31a1,1,0,0,1,1,1.12L283.51,292A1,1,0,0,1,282.48,293Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.51,292l2.24-26.87c-13-.76-28.52,3.44-46.23,14.74-13.05,8.32-22.24,9.53-28.07,8.77l.27,3.36a1,1,0,0,0,1,.94h69.72A1,1,0,0,0,283.51,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2,269.94c0,2.72-2.95,4.92-6.58,4.92s-6.59-2.2-6.59-4.92S244,265,247.62,265,254.2,267.23,254.2,269.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.15,293.4a55.75,55.75,0,0,1-8.16,7.4c-4.85,3.57-2.3,8.67-2,13.52s4.08,22.18,12.75,23.2,6.38-33.41,15.3-36.47,29.84,1.28,42.59,1.53,9.44-7.14,9.44-7.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-5--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.21,182.7v26l39.31,22.7V205.24ZM416.27,220l-26.82-15.49V193.73l26.82,15.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.27 193.73 416.27 201.72 422.52 205.24 422.52 182.71 383.21 205.24 383.21 231.39 403.05 219.94 403.05 212.19 389.45 220.04 389.45 209.1 403.05 201.31 403.05 194.08 409.42 197.66 416.27 193.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.27 209.1 412.27 206.86 403.17 212.12 409.72 216.09 416.27 212.3 416.27 209.1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-4--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.97,
    y: 114.13,
    width: 55.72,
    height: 15.09,
    transform: "translate(-8.23 216.45) rotate(-34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.12,
    y: 96.62,
    width: 13.54,
    height: 17.85,
    transform: "matrix(0.83, -0.56, 0.56, 0.83, -0.91, 208.13)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.29,
    y: 128.02,
    width: 13.54,
    height: 17.85,
    transform: "translate(-14.84 225.34) rotate(-34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.21,
    y: 96.87,
    width: 7.41,
    height: 9.65,
    transform: "translate(3.48 214.76) rotate(-34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.85,
    y: 121.76,
    width: 7.41,
    height: 6.23,
    transform: "translate(-6.81 227.47) rotate(-34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.5,
    y: 112.1,
    width: 9.49,
    height: 9.71,
    transform: "translate(-8.94 204.68) rotate(-34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.14,
    y: 137.05,
    width: 9.49,
    height: 6.17,
    transform: "translate(-19.23 217.39) rotate(-34)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.48,
    y: 141.19,
    width: 4.32,
    height: 4.35,
    transform: "matrix(0.56, 0.83, -0.83, 0.56, 267.66, -216.71)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.51,
    y: 105.82,
    width: 3.49,
    height: 3.51,
    transform: "translate(233.42 -223.88) rotate(56)",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-3--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.06 52.09 223.45 60.11 226.8 92 247.06 103.23 247.06 52.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.14 52.09 270.74 60.11 267.4 92 247.14 103.23 247.14 52.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,90.94h4.91L247.1,58.33,232.3,90.94h4.91l3.39-7.48h13Zm-14.3-12.07,4.41-9.72,4.41,9.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-2--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "155.48 106.17 149.12 95.15 126.63 95.15 155.48 145.13 184.33 95.15 161.84 95.15 155.48 106.17",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.48 106.17 149.12 95.15 138.22 95.15 155.48 125.06 172.75 95.15 161.84 95.15 155.48 106.17",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--icon-1--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.07,190.23c-1-.39-2.08-.74-3.2-1.06.25-1.14.44-2.25.58-3.32.78-6.22-.5-10.56-3.6-12.23s-7.43-.36-12.2,3.69c-.6.51-1.2,1.06-1.79,1.64-.61-.58-1.21-1.12-1.81-1.62-4.82-4-9.17-5.27-12.24-3.56S84.5,179.84,85.34,186c.15,1.07.35,2.17.61,3.3-1.11.33-2.17.69-3.17,1.09-5.83,2.29-9,5.5-9,9s3.25,6.69,9.09,8.93c1,.39,2.08.74,3.21,1.06-.25,1.14-.44,2.25-.58,3.32-.78,6.22.5,10.56,3.6,12.23a5.94,5.94,0,0,0,2.91.71c2.68,0,5.87-1.49,9.29-4.4.6-.51,1.19-1.06,1.79-1.64.6.58,1.21,1.12,1.81,1.62,3.42,2.84,6.6,4.3,9.26,4.3a6,6,0,0,0,3-.74c3.08-1.71,4.31-6.06,3.46-12.27-.14-1.07-.35-2.17-.6-3.3,1.11-.33,2.17-.69,3.17-1.08,5.83-2.3,9-5.51,9-9S128.92,192.47,123.07,190.23Zm-9.14-14.42a3.18,3.18,0,0,1,1.54.36c1.92,1,2.7,4.52,2.1,9.32-.12,1-.29,2-.51,3a58.21,58.21,0,0,0-7.11-1.09,58.07,58.07,0,0,0-5.06-6.37c.54-.53,1.09-1,1.64-1.49C109.36,177.11,112,175.81,113.93,175.81Zm1,27c.6,1.52,1.1,3,1.52,4.4-1.37.31-2.82.58-4.36.8.56-.94,1.11-1.9,1.64-2.88C114.15,204.35,114.55,203.58,114.93,202.8Zm-3.75.94c-.89,1.66-1.81,3.21-2.76,4.67-1.72.14-3.53.22-5.41.23s-3.67,0-5.4-.18c-1-1.47-1.91-3-2.81-4.63s-1.58-3-2.27-4.47q1-2.21,2.22-4.49t2.76-4.67c1.73-.14,3.54-.22,5.41-.23h.36c1.71,0,3.4.06,5,.18,1,1.47,1.91,3,2.8,4.63s1.6,3,2.28,4.47C112.74,200.74,112,202.25,111.18,203.74Zm-8.12,11.76q-1.69-1.84-3.33-4,1.45.06,2.94.06H103c1.11,0,2.21,0,3.3-.09A51.33,51.33,0,0,1,103.06,215.5ZM92.27,205.24c.54,1,1.1,1.92,1.67,2.85-1.54-.2-3-.46-4.36-.76.4-1.4.89-2.87,1.46-4.4C91.44,203.7,91.84,204.47,92.27,205.24ZM91,195.81c-.59-1.5-1.09-3-1.52-4.4,1.37-.31,2.82-.58,4.36-.8Q93,192,92.2,193.49C91.79,194.26,91.39,195,91,195.81Zm11.87-12.7q1.7,1.84,3.33,4c-1.09,0-2.19-.07-3.3-.06s-2.22,0-3.31.09C100.67,185.7,101.77,184.35,102.88,183.11Zm10.79,10.26c-.54-1-1.1-1.92-1.67-2.84q2.27.3,4.35.75c-.4,1.43-.89,2.9-1.46,4.39C114.5,194.91,114.09,194.14,113.67,193.37Zm-25.45-7.72c-.66-4.8.09-8.29,2-9.34a3.25,3.25,0,0,1,1.59-.38c1.93,0,4.56,1.27,7.39,3.63.55.46,1.11.95,1.66,1.48a56.25,56.25,0,0,0-5,6.41,59.79,59.79,0,0,0-7.1,1.16C88.53,187.59,88.35,186.6,88.22,185.65ZM76.67,199.43c0-2.61,3.74-5.41,10-7.28a59.37,59.37,0,0,0,2.67,7.23,58.77,58.77,0,0,0-2.59,7.25C80.47,204.82,76.68,202.05,76.67,199.43Zm13.79,23c-2.29-1.24-2.95-5.89-1.58-12.3a58.35,58.35,0,0,0,7.1,1.09,59.09,59.09,0,0,0,5.07,6.37c-3.5,3.38-6.74,5.21-9,5.21A3.18,3.18,0,0,1,90.46,222.44Zm25.27-.13c-1.91,1.05-5.27-.17-9-3.26q-.83-.69-1.65-1.47a58.48,58.48,0,0,0,5-6.42,59.79,59.79,0,0,0,7.1-1.16C118.61,216.39,118,221,115.73,222.31Zm3.52-15.85a61.09,61.09,0,0,0-2.67-7.23,61.61,61.61,0,0,0,2.59-7.25c1,.29,2,.61,2.87,1,4.51,1.73,7.22,4.06,7.23,6.24C129.28,201.79,125.52,204.59,119.25,206.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,199a5.46,5.46,0,1,1-5.46-5.46A5.45,5.45,0,0,1,108.43,199Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.48,
    cy: 290.64,
    rx: 15.58,
    ry: 7.34,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.48,
    cy: 290.64,
    rx: 15.58,
    ry: 7.34,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,275.6l1.83,14.61c0,2.3,4.75,4.16,10.6,4.16s10.61-1.86,10.61-4.16l1.83-14.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.21,
    cy: 275.6,
    rx: 12.43,
    ry: 4.87,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.21,
    cy: 275.6,
    rx: 10.6,
    ry: 3.73,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.23,277.15s-6.54-3-7.84-5.54-.29-8-.29-8a12.42,12.42,0,0,1,6.29,5.07A18.1,18.1,0,0,1,336.23,277.15Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.19,277s.25-8,2.19-11.11,8.66-4.78,8.66-4.78-.65,5.94-3.1,9.69S336.19,277,336.19,277Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.09,277.52s-3.75-4.4-3.75-9.44,4-8.91,4-8.91a20,20,0,0,1,3.36,8.14C341.23,271.57,337.09,277.52,337.09,277.52Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScriptframeworksBro);
export default __webpack_public_path__ + "static/media/JavaScript frameworks-bro.efcdca7d9ce80afd68e31b8f6ae55759.svg";
export { ForwardRef as ReactComponent };